"use strict";
import { scrollLock } from "./_scrollLock";

/**
 * モーダルのイベント初期化
 * @param {Object} elements - {modal, triggers, closeButton}
 * @param {HTMLElement} elements.modal
 * @param {HTMLElement[]|HTMLElement} elements.triggers
 * @param {HTMLElement} elements.closeButton
 */
export function initModal({ modal, triggers, closeButton }) {
  if (Array.isArray(triggers)) {
    triggers.forEach((trigger, index) => {
      let currentIndex = index;
      if (trigger.dataset.index) currentIndex = parseInt(trigger.dataset.index);
      trigger.addEventListener("click", () => openModal(modal, currentIndex));
    });
  } else if (triggers) {
    triggers.addEventListener("click", () => openModal(modal, 0));
  }

  modal.addEventListener("click", e => clickOutsideModal(modal, e));
  closeButton.addEventListener("click", () => closeModal(modal));
  document.addEventListener("keydown", e => handleEscClose(modal, e));
}

export function openModal(modal, index = 0) {
  modal.showModal();
  requestAnimationFrame(() => modal.classList.remove('-closing'));
  scrollLock();   // スクロールロック発動（トグル型）
  resetScroll(modal);
}

export function closeModal(modal) {
  if (!modal.classList.contains('-closing')) {
    const handleTransitionEnd = () => {
      modal.close();
      scrollLock(); // スクロールロック解除（トグル型）
    };
    modal.addEventListener('transitionend', handleTransitionEnd, { once: true });
    modal.classList.add('-closing');
  }
}

function clickOutsideModal(modal, event) {
  const elRect = modal.getBoundingClientRect();
  const isInDialog =
    elRect.top <= event.clientY && event.clientY <= elRect.bottom &&
    elRect.left <= event.clientX && event.clientX <= elRect.right;
  if (isInDialog) return;
  closeModal(modal);
}

function handleEscClose(modal, event) {
  if (event.key === "Escape") {
    event.preventDefault();
    closeModal(modal);
  }
}

/**
 * モーダル内要素のスクロールを先頭に戻す
 * @param {HTMLElement} modal 
 * @param {string} [selector='.modal__inner']
 */
export function resetScroll(modal, selector = '.modal__inner') {
  const scrollElement = modal.querySelector(selector);
  if (scrollElement) {
    scrollElement.scrollTop = 0;
  }
}